import React from 'react';
import { Layout } from 'react-admin';
import TomYoMenu from './TomYoMenu';

const MyLayout = (props) => <Layout {...props} menu={TomYoMenu} />;

export default MyLayout;